export default function utcToLocalTime (input) {
    if(!input || !input.match(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)) {
        return input;
    }
    const now = new Date();
    const timeSplit = input.split(':');
    const utcTime = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), timeSplit[0], timeSplit[1]));

    return `${String(utcTime.getHours()).padStart(2, "0")}:${String(utcTime.getMinutes()).padStart(2, "0")}`;
};
